DO.Subscribe('app:ready', () => {
  // Had to remove default click action on video element button **functions need to be named
  function removeDefaultEventListenerYoutubeModule() {
    Array.prototype.slice.call(document.querySelectorAll('.postsummary .youtube-embed__poster')).forEach((item) => {
      item.removeEventListener('click', videoClick);
    });
  }

  function videoClickLightBox(e) {
    const container = e.currentTarget.closest('.youtube-embed__container');
    const iframe = container.querySelector('iframe');
    const src = iframe.getAttribute('data-src');
    lity(src);
  }

  function addEventListenerYoutubeModule() {
    Array.prototype.slice.call(document.querySelectorAll('.postsummary .youtube-embed__poster')).forEach((item) => {
      item.addEventListener('click', videoClickLightBox);
    });
  }

  DO.Subscribe('app:yt-module-events', () => {
    removeDefaultEventListenerYoutubeModule();
    addEventListenerYoutubeModule();
  });

  removeDefaultEventListenerYoutubeModule();
  addEventListenerYoutubeModule();
});
